import Enums from 'utils/EnumsManager';

const { INVOICE } = Enums.REDUX_ACTION_TYPE_PREFIX;

export const SET_CI_FORM = `${INVOICE}_SET_CI_FORM`;
export const SET_CI_FIELD = `${INVOICE}_SET_CI_FIELD`;



// WEBPACK FOOTER //
// ./src/views/Invoice/flow/ciForm/actionTypes.js